export const FormTypesEnum = Object.freeze({
    'open': 1,
    'close': 2
})